export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const AUDIO_IS_PLAYING = "AUDIO_IS_PLAYING";
export const AUDIO_LOOP = "AUDIO_LOOP";
